import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
dayjs.extend(customParseFormat);
export const abstractFormatToString = (formattedDate, format, callback) => {
  if (!formattedDate) return null;
  const dateObj = dayjs(formattedDate, format, true);
  if (dateObj.isValid()) {
    return callback(dateObj);
  }
  return null;
};

/**
 * Date util that parses a formatted string date and returns a fully UTC ISO8601 string date.
 *
 * @example formatToIsoStringUTC('30/03/2022', 'DD/MM/YYYY') -> '2022-03-30T00:00:00.000Z'
 *
 */
export const formatToIsoStringUTC = (formattedDate, sourceFormat) => {
  return abstractFormatToString(formattedDate, sourceFormat, dateObj => dateObj.toISOString());
};

/**
 * Date util that parses a formatted string date and returns a shorthand calendar ISO8601 string date.
 *
 * @example formatToIsoStringCalendar('30/03/2022', 'DD/MM/YYYY') -> '2022-03-30'
 *
 */
export const formatToIsoStringCalendar = (formattedDate, sourceFormat) => {
  return abstractFormatToString(formattedDate, sourceFormat, dateObj => dateObj.format('YYYY-MM-DD'));
};

/**
 * Date util that parses a formatted string date and returns another formatted string date.
 *
 * @example formatToFormat('30/03/2022', 'DD/MM/YYYY', 'MM/DD/YYYY') -> '03/30/2022'
 *
 */
export const formatToFormat = (formattedDate, sourceFormat, resultFormat) => {
  return abstractFormatToString(formattedDate, sourceFormat, dateObj => dateObj.format(resultFormat));
};

/**
 * Date util that formats an iso string date.
 *
 * @example dateFormat('2022-03-30T00:00:00.000Z', 'DD/MM/YYYY') -> '30/03/2022'
 * @example dateFormat('2022-03-30', 'DD/MM/YYYY') -> '30/03/2022'
 *
 */
export const isoStringToFormat = (isoDate, format) => {
  if (!isoDate) return null;
  return dayjs(isoDate).format(format);
};

/**
 * Date util that parses a formatted string date into a Date object.
 *
 * @example dateParse('30/03/2022', 'DD/MM/YYYY') -> [Object]
 *
 */
export const dateParse = (formattedDate, format) => {
  if (!formattedDate) return null;
  const dateObj = dayjs(formattedDate, format, true);
  if (dateObj.isValid()) return dateObj.toDate();
  return null;
};

/**
 * Date util that formats an iso string date or Date object.
 *
 * @example dateFormat('2022-03-30T00:00:00.000Z', 'DD/MM/YYYY') -> '30/03/2022'
 * @example dateFormat('2022-03-30', 'DD/MM/YYYY') -> '30/03/2022'
 *
 */
export const dateFormat = (isoDate, format) => {
  return dayjs(isoDate).format(format);
};
export { dayjs };